// extracted by mini-css-extract-plugin
export default {"button":"CampaignsTable__button-xHCmS"};